module.exports = __webpack_public_path__ + "img/t5-7.acaee100.svg";